import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Switch, TextField, Typography } from "@mui/material";
import { DataGrid, GridEventListener } from "@mui/x-data-grid";
import CookieJs from "js-cookie";
import get from "lodash/get";
import { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import category from "../services/category";

const NoOverlay = () => (
  <Box sx={{ pt: 5 }}>
    <Typography variant="body1" textAlign="center" fontWeight="600">
      Please upload the ticket list to generate category
    </Typography>
  </Box>
);

export default function Category(params: any) {
  const { id } = params;
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState<any>(null);
  const [editCategoryName, setEditCategoryName] = useState("");
  const [editMaskedTotal, setEditMaskedTotal] = useState<string | number>("");
  const [editMaskedRedeem, setEditMaskedRedeem] = useState<string | number>("");
  const [editMaskedCheckin, setEditMaskedCheckin] = useState<string | number>("");
  const [editMaskedFirstCheckin, setEditMaskedFirstCheckin] = useState<string | number>("");

  const listCategory = useQuery("list-category", () =>
    category.getCategoryByEventId({ event_id: id })
  );
  const navigate = useNavigate();
  const handleEvent: GridEventListener<'cellClick'> = (
    params
  ) => {
    if (params.field !== 'redeem_active' && params.field !== 'checkin_active' && params.field !== 'edit') {
      navigate(`/app/event/category-detail/${params.id}`);
    }
  };

  const handleEditClick = (categoryData: any) => {
    setEditingCategory(categoryData);
    setEditCategoryName(categoryData.category);
    setEditMaskedTotal(categoryData.masked_ticket || "");
    setEditMaskedRedeem(categoryData.masked_redeem || "");
    setEditMaskedCheckin(categoryData.masked_checkin || "");
    setEditMaskedFirstCheckin(categoryData.masked_first_checkin || "");
    setIsEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
    setEditingCategory(null);
    setEditMaskedTotal("");
    setEditMaskedRedeem("");
    setEditMaskedCheckin("");
    setEditMaskedFirstCheckin("");
    setEditCategoryName("");
  };

  const user = JSON.parse(CookieJs.get("USER") || "");
  const handleSubmitEdit = () => {
    category.updateCategory({
      id: editingCategory.id,
      category: editCategoryName,
      masked_ticket: editMaskedTotal === "" ? 0 : Number(editMaskedTotal),
      masked_redeem: editMaskedRedeem === "" ? 0 : Number(editMaskedRedeem),
      masked_checkin: editMaskedCheckin === "" ? 0 : Number(editMaskedCheckin),
      masked_first_checkin: editMaskedFirstCheckin === "" ? 0 : Number(editMaskedFirstCheckin),
      username: user.username,
    }).then(() => listCategory.refetch());
    handleCloseModal();
  };
  return (
    <Box sx={{ mt: 2 }}>
      <DataGrid
        hideFooterPagination
        autoHeight
        disableSelectionOnClick
        disableColumnMenu
        loading={listCategory.isLoading}
        getRowId={(record) => get(record, "id")}
        rows={get(listCategory, "data.data", [])}
        rowCount={get(listCategory, "data.data", []).length}
        components={{
          NoRowsOverlay: NoOverlay,
        }}
        onCellClick={handleEvent}
        columns={[
          {
            field: "category",
            headerName: "Category",
            flex: 1,
            minWidth: 250,
            sortable: false,
            filterable: false,
            headerAlign: "center",
          },
          {
            field: "total_all",
            headerName: "Total Ticket",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            align: "center"
          },
          {
            field: "redeem_total",
            headerName: "Total Redeem",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            align: "center"
          },
          {
            field: "checkin_total",
            headerName: "Total Checkin",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            align: "center"
          },
          {
            field: "first_checkin_total",
            headerName: "Total First Checkin",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            align: "center"
          },
          {
            field: "redeem_active",
            headerName: "Redeem Active",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            renderCell: (params) => {
              const handleChange = (e: any) => {
                e.stopPropagation();
                category.changeRedeemStatus(params.row.id).then(() => listCategory.refetch());
              };

              return <Switch
                checked={params.value}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />;
            }
          },
          {
            field: "checkin_active",
            headerName: "Checkin Active",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            renderCell: (params) => {
              const handleChange = (e: any) => {
                e.stopPropagation();
                category.changeCheckinStatus(params.row.id).then(() => listCategory.refetch());
              };

              return <Switch
                checked={params.value}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />;
            }
          },
          {
            field: "edit",
            headerName: "Edit",
            flex: 1,
            minWidth: 150,
            sortable: false,
            filterable: false,
            headerAlign: "center",
            renderCell: (params) => {
              const handleChange = (e: any) => {
                e.stopPropagation();
                handleEditClick(params.row);
              };
              return <Button onClick={handleChange}>
                Edit
              </Button>;
            }
          },
        ]}
        sx={{
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 600,
          },
        }}
      />

      <Dialog open={isEditModalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Category</DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={2}>
            <TextField
              autoFocus
              margin="dense"
              label="Category Name"
              type="text"
              fullWidth
              variant="outlined"
              value={editCategoryName}
              onChange={(e) => setEditCategoryName(e.target.value)}
              sx={{ mt: 2 }}
            />
            <TextField
              autoFocus
              margin="dense"
              label="Masked Total"
              type="text"
              fullWidth
              variant="outlined"
              value={editMaskedTotal}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || /^\d+$/.test(value)) {
                  setEditMaskedTotal(value);
                }
              }}
              sx={{ mt: 2 }}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            />
            <TextField
              autoFocus
              margin="dense"
              label="Masked Redeem"
              type="text"
              fullWidth
              variant="outlined"
              value={editMaskedRedeem}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || /^\d+$/.test(value)) {
                  setEditMaskedRedeem(value);
                }
              }}
              sx={{ mt: 2 }}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            />
            <TextField
              autoFocus
              margin="dense"
              label="Masked Checkin"
              type="text"
              fullWidth
              variant="outlined"
              value={editMaskedCheckin}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || /^\d+$/.test(value)) {
                  setEditMaskedCheckin(value);
                }
              }}
              sx={{ mt: 2 }}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            />
            <TextField
              autoFocus
              margin="dense"
              label="Masked First Checkin"
              type="text"
              fullWidth
              variant="outlined"
              value={editMaskedFirstCheckin}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || /^\d+$/.test(value)) {
                  setEditMaskedFirstCheckin(value);
                }
              }}
              sx={{ mt: 2 }}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleSubmitEdit} variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
